/**
 * 全站http配置
 *
 * axios参数说明
 * isSerialize是否开启form表单提交
 * isToken是否需要token
 */
import axios from 'axios'
import website from '@/config/website'
import { serialize } from '@/utils/util'
import { getToken } from '@/utils/auth'
import { ElMessage } from 'element-plus'
import { setToken } from '@/utils/auth'
import { getStore, setStore } from '@/utils/store'
import useUserStore from '@/store/user'
import lang from '@/lang/index'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style

const i18n = lang.global

axios.defaults.timeout = 20000

//返回其他状态吗
axios.defaults.validateStatus = function (status) {
	return status >= 200 && status < 300
}

//跨域请求，允许保存cookie
axios.defaults.withCredentials = false

// NProgress Configuration
NProgress.configure({
	showSpinner: false
})

// 401 防抖标记，避免多个 401 同时触发 login drawer 反复开关
let isHandling401 = false

//HTTPrequest拦截
axios.interceptors.request.use(
	(config: any) => {
		NProgress.start() // start progress bar
		const meta = config.meta || {}
		const isToken = meta.isToken === false

		//拼接token
		config.headers['Authorization'] = ''
		if (getToken() && !isToken) {
			config.headers['Authorization'] = getToken()
		}

		//多语言
		const lang = getStore({ name: 'language' }) || 'en'
		const langIndex = getStore({ name: 'langIndex' }) || 2
		// URL 参数拼接：检查是否已有查询参数，有则用 & 否则用 ?
		const separator = config.url && config.url.includes('?') ? '&' : '?'
		config.url = `${config.url}${separator}buId=${website.buId}&lang=${lang}&langIndex=${langIndex}`

		// POST 请求统一拼接 buId
		if (config.method === 'post') {
			config.data = config.data || {}
			config.data.buId = website.buId

			//headers中配置serialize为true开启序列化
			if (meta.isSerialize === true) {
				config.data = serialize(config.data)
			}
		}

		// GET 请求统一拼接 buid
		if (config.method === 'get' && !meta.noBuId) {
			config.params = config.params || {}
			config.params.buId = website.buId
		}

		return config
	},
	(error) => {
		return Promise.reject(error)
	}
)

//HTTPresponse拦截
axios.interceptors.response.use(
	(res: any) => {
		NProgress.done()
		const status = res.status
		const userStore = useUserStore()
		// 如果是401则跳转到登录页面
		if (status === 401) {
			if (!isHandling401) {
				isHandling401 = true
				userStore.setUpdateLogin()
				userStore.setUserInfo({ id: '' })
				setToken('')
				setStore({ name: 'loginInfo', content: { id: '' } })
				// 延迟重置标记，防止多个 401 在短时间内反复触发
				setTimeout(() => {
					isHandling401 = false
				}, 1000)
			}
			return Promise.reject(new Error(i18n.t('uChoicePc.loginExpired')))
		}
		// 如果请求为非200否者默认统一处理
		if (status !== 200 && status !== 201) {
			const message = res.msg || i18n.t('uChoicePc.networkTimeout')
			ElMessage({
				message: message,
				type: 'warning'
			})
			return Promise.reject(new Error(message))
		}
		return Promise.resolve(res.data)
	},
	(error) => {
		NProgress.done()
		return Promise.reject(error)
	}
)

export default axios
